import React, {
  useState,
  useEffect,
  useContext,
} from "react";

import AgregarTipoDb from "../firebase/AgregarTipoDb";
import Alertas from "./Alertas";

import {
  auth,
  db,
} from "../firebase/firebaseConfig";

import { useNavigate } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";

import {
  getDocs,
  collection,
  where,
  query,
  limit,
} from "firebase/firestore";

import { UserContext } from "../context/UserContext";
import ExportarExcel from "../funciones/ExportarExcel";

import {
  Table,
  Container,
  Segment,
  Input,
  Form,
  Header,
  Dropdown,
  Button,
  Icon,
} from "semantic-ui-react";

const AgregarTipo = () => {
  const user = auth.currentUser;
  const { users } = useContext(UserContext);

  const navigate = useNavigate();

  const [
    estadoAlerta,
    cambiarEstadoAlerta,
  ] = useState(false);

  const [
    alerta,
    cambiarAlerta,
  ] = useState({});

  const [
    tipo,
    setTipo,
  ] = useState("");

  const [
    leer,
    setLeer,
  ] = useState([]);

  const [
    familia,
    setFamilia,
  ] = useState([]);

  const [
    fam,
    setFam,
  ] = useState("");

  const [
    buscador,
    setBuscador,
  ] = useState("");

  const [
    flag,
    setFlag,
  ] = useState(false);

  /*
   * Guarda el ID del tipo que se está
   * verificando antes de permitir editarlo.
   */
  const [
    verificandoId,
    setVerificandoId,
  ] = useState(null);

  // ==========================================================
  // AGREGAR TIPO
  // ==========================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    const tipoNormalizado =
      String(tipo || "")
        .toLocaleUpperCase()
        .trim();

    // ========================================================
    // VALIDAR TIPO
    // ========================================================

    if (!tipoNormalizado) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No ha ingresado un Tipo de Equipamiento.",
      });

      return;
    }

    // ========================================================
    // VALIDAR FAMILIA
    // ========================================================

    if (
      !fam ||
      fam === "Selecciona Opción:"
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No ha seleccionado una Familia.",
      });

      return;
    }

    // ========================================================
    // VALIDAR DUPLICADO
    //
    // Se mantiene la lógica de tu aplicación:
    // el nombre del Tipo debe ser único dentro de la empresa.
    // ========================================================

    const existe = leer.some(
      (item) =>
        String(item.tipo || "")
          .toLocaleUpperCase()
          .trim() === tipoNormalizado
    );

    if (existe) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Ya existe este Tipo de Equipamiento.",
      });

      return;
    }

    // ========================================================
    // GUARDAR
    // ========================================================

    try {
      const fechaActual =
        new Date();

      await AgregarTipoDb({
        tipo:
          tipoNormalizado,

        activo:
          true,

        familia:
          fam,

        userAdd:
          user?.email || "",

        userMod:
          user?.email || "",

        fechaAdd:
          fechaActual,

        fechaMod:
          fechaActual,

        emp_id:
          users.emp_id,
      });

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "exito",
        mensaje:
          "Tipo de Equipamiento ingresado correctamente.",
      });

      setTipo("");
      setFam("");

      setFlag(
        (prev) => !prev
      );
    } catch (error) {
      console.error(
        "Error al agregar Tipo:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible ingresar el Tipo de Equipamiento.",
      });
    }
  };

  // ==========================================================
  // OBTENER FAMILIAS
  // ==========================================================

  const getFamilia = async () => {
    if (!users?.emp_id) {
      return;
    }

    try {
      const familiasRef =
        collection(
          db,
          "familias"
        );

      const qFamilias =
        query(
          familiasRef,

          where(
            "emp_id",
            "==",
            users.emp_id
          ),

          where(
            "activo",
            "==",
            true
          )
        );

      const data =
        await getDocs(
          qFamilias
        );

      const familias =
        data.docs
          .map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
          .sort((a, b) =>
            String(
              a.familia || ""
            ).localeCompare(
              String(
                b.familia || ""
              )
            )
          );

      setFamilia(
        familias
      );
    } catch (error) {
      console.error(
        "Error cargando familias:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible cargar las familias.",
      });
    }
  };

  // ==========================================================
  // OBTENER TIPOS
  // ==========================================================

  const getData = async () => {
    if (!users?.emp_id) {
      return;
    }

    try {
      const tiposRef =
        collection(
          db,
          "tipos"
        );

      const qTipos =
        query(
          tiposRef,

          where(
            "emp_id",
            "==",
            users.emp_id
          ),

          where(
            "activo",
            "==",
            true
          )
        );

      const data =
        await getDocs(
          qTipos
        );

      const tipos =
        data.docs
          .map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
          .sort((a, b) =>
            String(
              a.tipo || ""
            ).localeCompare(
              String(
                b.tipo || ""
              )
            )
          );

      setLeer(
        tipos
      );
    } catch (error) {
      console.error(
        "Error cargando tipos:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible cargar los Tipos de Equipamiento.",
      });
    }
  };

  // ==========================================================
  // VERIFICAR SI EL TIPO YA ESTÁ SIENDO UTILIZADO
  // ==========================================================

  const verificarTipoEnUso =
    async (nombreTipo) => {
      if (!users?.emp_id) {
        throw new Error(
          "No se encontró la empresa del usuario"
        );
      }

      const tipoNormalizado =
        String(
          nombreTipo || ""
        )
          .toLocaleUpperCase()
          .trim();

      if (!tipoNormalizado) {
        return false;
      }

      // ======================================================
      // 1. HOMECARE
      // Primera propagación: equipos
      // ======================================================

      const qEquipos =
        query(
          collection(
            db,
            "equipos"
          ),

          where(
            "emp_id",
            "==",
            users.emp_id
          ),

          where(
            "tipo",
            "==",
            tipoNormalizado
          ),

          limit(1)
        );

      const snapEquipos =
        await getDocs(
          qEquipos
        );

      /*
       * Si encontramos al menos un equipo,
       * el Tipo ya fue propagado.
       */
      if (
        !snapEquipos.empty
      ) {
        return true;
      }

      // ======================================================
      // 2. SERVICIO TÉCNICO
      // Primera propagación: ingresostcab
      // ======================================================

      const qIngresos =
        query(
          collection(
            db,
            "ingresostcab"
          ),

          where(
            "emp_id",
            "==",
            users.emp_id
          ),

          where(
            "tipo",
            "==",
            tipoNormalizado
          ),

          limit(1)
        );

      const snapIngresos =
        await getDocs(
          qIngresos
        );

      if (
        !snapIngresos.empty
      ) {
        return true;
      }

      /*
       * No aparece ni en equipos
       * ni en ingresostcab.
       *
       * Se puede modificar.
       */
      return false;
    };

  // ==========================================================
  // EDITAR TIPO
  // ==========================================================

  const editarTipo =
    async (item) => {
      if (
        !item?.id ||
        !item?.tipo
      ) {
        return;
      }

      cambiarEstadoAlerta(
        false
      );

      cambiarAlerta({});

      setVerificandoId(
        item.id
      );

      try {
        const enUso =
          await verificarTipoEnUso(
            item.tipo
          );

        if (enUso) {
          cambiarEstadoAlerta(
            true
          );

          cambiarAlerta({
            tipo: "error",

            mensaje:
              "Este tipo ya está siendo utilizado en el sistema y no puede modificarse.",
          });

          return;
        }

        /*
         * Solamente llegamos aquí si
         * el Tipo todavía no ha sido propagado.
         */
        navigate(
          `/actualizatipo/${item.id}`
        );
      } catch (error) {
        console.error(
          "Error verificando uso del Tipo:",
          error
        );

        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",

          mensaje:
            "No fue posible verificar si el Tipo puede modificarse.",
        });
      } finally {
        setVerificandoId(
          null
        );
      }
    };

  // ==========================================================
  // FILTRO
  // ==========================================================

  const filtroTipo =
    leer.filter(
      (item) =>
        Object.keys(
          item
        ).some(
          (key) =>
            String(
              item[key] ?? ""
            )
              .toLowerCase()
              .includes(
                buscador.toLowerCase()
              )
        )
    );

  // ==========================================================
  // EXPORTAR EXCEL
  // ==========================================================

  const ExportarXls =
    () => {
      const columnsToShow =
        [
          "id",
          "familia",
          "tipo",
        ];

      const excelBlob =
        ExportarExcel(
          leer,
          columnsToShow
        );

      const excelURL =
        URL.createObjectURL(
          excelBlob
        );

      const downloadLink =
        document.createElement(
          "a"
        );

      downloadLink.href =
        excelURL;

      downloadLink.download =
        "tipo.xlsx";

      document.body.appendChild(
        downloadLink
      );

      downloadLink.click();

      document.body.removeChild(
        downloadLink
      );

      URL.revokeObjectURL(
        excelURL
      );
    };

  // ==========================================================
  // USE EFFECT
  // ==========================================================

  useEffect(() => {
    getData();
    getFamilia();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    flag,
    users?.emp_id,
  ]);

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <Container
      fluid
      style={{
        maxWidth:
          1400,
        padding:
          "24px 28px",
        background:
          "#f8fafc",
        minHeight:
          "100vh",
      }}
    >
      {/* ==================================================== */}
      {/* ENCABEZADO */}
      {/* ==================================================== */}

      <div
        style={{
          display:
            "flex",
          justifyContent:
            "space-between",
          alignItems:
            "center",
          marginBottom:
            20,
          gap:
            20,
          flexWrap:
            "wrap",
        }}
      >
        <div
          style={{
            display:
              "flex",
            alignItems:
              "center",
            gap:
              14,
          }}
        >
          <div
            style={{
              width:
                48,
              height:
                48,
              minWidth:
                48,
              borderRadius:
                12,
              background:
                "#e5f7f7",
              display:
                "flex",
              alignItems:
                "center",
              justifyContent:
                "center",
            }}
          >
            <Icon
              name="tags"
              style={{
                margin:
                  0,
                color:
                  "#0d9da5",
                fontSize:
                  21,
              }}
            />
          </div>

          <div>
            <Header
              as="h2"
              style={{
                margin:
                  0,
                color:
                  "#172b4d",
                fontSize:
                  24,
                fontWeight:
                  700,
              }}
            >
              Tipos de Equipos
            </Header>

            <div
              style={{
                color:
                  "#8793a5",
                fontSize:
                  13,
                marginTop:
                  4,
              }}
            >
              Administra los tipos de equipamiento médico y su familia asociada
            </div>
          </div>
        </div>

        <Button
          type="button"
          onClick={
            ExportarXls
          }
          style={{
            background:
              "#ffffff",
            color:
              "#526273",
            border:
              "1px solid #d7dee7",
            borderRadius:
              6,
            boxShadow:
              "none",
          }}
        >
          <Icon
            name="file excel outline"
            style={{
              color:
                "#21ba45",
            }}
          />

          Exportar Excel
        </Button>
      </div>

      {/* ==================================================== */}
      {/* AGREGAR NUEVO TIPO */}
      {/* ==================================================== */}

      <Segment
        style={{
          borderRadius:
            8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding:
            0,
          background:
            "#ffffff",
          overflow:
            "visible",
          marginBottom:
            14,
        }}
      >
        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display:
              "flex",
            alignItems:
              "center",
            gap:
              9,
            fontWeight:
              600,
            color:
              "#253858",
          }}
        >
          <Icon
            name="plus circle"
            style={{
              color:
                "#0d9da5",
            }}
          />

          Agregar nuevo tipo
        </div>

        <div
          style={{
            padding:
              18,
          }}
        >
          <Form
            onSubmit={
              handleSubmit
            }
          >
            <div
              style={{
                display:
                  "grid",
                gridTemplateColumns:
                  "minmax(260px, 1fr) minmax(300px, 1.5fr) auto",
                gap:
                  10,
                alignItems:
                  "center",
              }}
            >
              {/* ============================================ */}
              {/* FAMILIA */}
              {/* ============================================ */}

              <Dropdown
                fluid
                search
                selection
                clearable
                placeholder="Selecciona Familia"
                value={
                  fam || ""
                }
                onChange={(
                  e,
                  { value }
                ) =>
                  setFam(
                    value || ""
                  )
                }
                options={
                  familia.map(
                    (item) => ({
                      key:
                        item.id,
                      text:
                        item.familia,
                      value:
                        item.familia,
                    })
                  )
                }
              />

              {/* ============================================ */}
              {/* TIPO */}
              {/* ============================================ */}

              <Input
                fluid
                size="large"
                icon="tag"
                iconPosition="left"
                type="text"
                placeholder="Ingrese Tipo de Equipamiento"
                name="tipo"
                value={
                  tipo
                }
                onChange={(
                  e
                ) =>
                  setTipo(
                    e.target.value
                  )
                }
              />

              {/* ============================================ */}
              {/* AGREGAR */}
              {/* ============================================ */}

              <Button
                type="submit"
                style={{
                  minWidth:
                    120,
                  height:
                    42,
                  background:
                    "#0d9da5",
                  color:
                    "#ffffff",
                  borderRadius:
                    6,
                  boxShadow:
                    "none",
                  margin:
                    0,
                }}
              >
                <Icon name="plus" />
                Agregar
              </Button>
            </div>
          </Form>
        </div>
      </Segment>

      {/* ==================================================== */}
      {/* LISTADO */}
      {/* ==================================================== */}

      <Segment
        style={{
          borderRadius:
            8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding:
            0,
          background:
            "#ffffff",
          overflow:
            "hidden",
        }}
      >
        {/* CABECERA */}

        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display:
              "flex",
            justifyContent:
              "space-between",
            alignItems:
              "center",
            gap:
              15,
            flexWrap:
              "wrap",
          }}
        >
          <div
            style={{
              display:
                "flex",
              alignItems:
                "center",
              gap:
                8,
              fontWeight:
                600,
              color:
                "#253858",
            }}
          >
            <Icon
              name="list"
              style={{
                color:
                  "#0d9da5",
              }}
            />

            Tipos registrados

            <span
              style={{
                marginLeft:
                  8,
                fontSize:
                  11,
                color:
                  "#98a1af",
                fontWeight:
                  400,
              }}
            >
              {
                filtroTipo.length
              }{" "}
              registros
            </span>
          </div>

          <div
            style={{
              width:
                340,
              maxWidth:
                "100%",
            }}
          >
            <Input
              fluid
              icon="search"
              iconPosition="left"
              placeholder="Buscar Tipo Equipamiento"
              value={
                buscador
              }
              onChange={(
                e
              ) =>
                setBuscador(
                  e.target.value
                )
              }
            />
          </div>
        </div>

        {/* ================================================== */}
        {/* TABLA */}
        {/* ================================================== */}

        <div
          style={{
            maxHeight:
              520,
            overflowY:
              "auto",
            overflowX:
              "auto",
          }}
        >
          <Table
            celled
            compact
            selectable
            style={{
              margin:
                0,
              border:
                0,
              borderRadius:
                0,
              fontSize:
                12,
            }}
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  width={1}
                  textAlign="center"
                  style={
                    stickyTh
                  }
                >
                  N°
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Tipo
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Familia
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Agregado por
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Modificado por
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={2}
                  textAlign="center"
                  style={
                    stickyTh
                  }
                >
                  Acción
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {filtroTipo.map(
                (
                  item,
                  index
                ) => (
                  <Table.Row
                    key={
                      item.id ||
                      index
                    }
                  >
                    <Table.Cell
                      textAlign="center"
                    >
                      {index +
                        1}
                    </Table.Cell>

                    <Table.Cell
                      style={{
                        fontWeight:
                          500,
                        color:
                          "#344563",
                        maxWidth:
                          280,
                        whiteSpace:
                          "nowrap",
                        overflow:
                          "hidden",
                        textOverflow:
                          "ellipsis",
                      }}
                      title={
                        item.tipo
                      }
                    >
                      {
                        item.tipo
                      }
                    </Table.Cell>

                    <Table.Cell
                      style={{
                        color:
                          "#526273",
                        maxWidth:
                          260,
                        whiteSpace:
                          "nowrap",
                        overflow:
                          "hidden",
                        textOverflow:
                          "ellipsis",
                      }}
                      title={
                        item.familia
                      }
                    >
                      {
                        item.familia ||
                        "-"
                      }
                    </Table.Cell>

                    <Table.Cell>
                      {item.useradd ||
                        item.userAdd ||
                        "-"}
                    </Table.Cell>

                    <Table.Cell>
                      {item.usermod ||
                        item.userMod ||
                        "-"}
                    </Table.Cell>

                    <Table.Cell
                      textAlign="center"
                    >
                      <Button
                        icon
                        size="mini"
                        type="button"
                        title="Editar Tipo"
                        loading={
                          verificandoId ===
                          item.id
                        }
                        disabled={
                          verificandoId !==
                            null &&
                          verificandoId !==
                            item.id
                        }
                        onClick={() =>
                          editarTipo(
                            item
                          )
                        }
                        style={{
                          width:
                            34,
                          height:
                            30,
                          padding:
                            0,
                          margin:
                            0,
                          borderRadius:
                            5,
                          border:
                            "1px solid #168bc1",
                          background:
                            "#f4fbfe",
                          boxShadow:
                            "none",
                        }}
                      >
                        {verificandoId !==
                          item.id && (
                          <FaRegEdit
                            style={{
                              fontSize:
                                15,
                              color:
                                "#168bc1",
                            }}
                          />
                        )}
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                )
              )}

              {filtroTipo.length ===
                0 && (
                <Table.Row>
                  <Table.Cell
                    colSpan={6}
                    textAlign="center"
                    style={{
                      padding:
                        28,
                      color:
                        "#8995a3",
                    }}
                  >
                    <Icon
                      name="search"
                      style={{
                        marginRight:
                          6,
                      }}
                    />

                    No se encontraron Tipos de Equipamiento
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>

        {/* ================================================== */}
        {/* FOOTER */}
        {/* ================================================== */}

        {filtroTipo.length >
          0 && (
          <div
            style={{
              padding:
                "12px 18px",
              borderTop:
                "1px solid #edf0f4",
              color:
                "#697586",
              fontSize:
                12,
            }}
          >
            Mostrando{" "}
            <strong>
              {
                filtroTipo.length
              }
            </strong>{" "}
            tipos
          </div>
        )}
      </Segment>

      {/* ==================================================== */}
      {/* ALERTAS */}
      {/* ==================================================== */}

      <Alertas
        tipo={
          alerta.tipo
        }
        mensaje={
          alerta.mensaje
        }
        estadoAlerta={
          estadoAlerta
        }
        cambiarEstadoAlerta={
          cambiarEstadoAlerta
        }
      />
    </Container>
  );
};

// ============================================================
// HEADER STICKY
// ============================================================

const stickyTh = {
  position:
    "sticky",
  top:
    0,
  zIndex:
    2,
  background:
    "#f8fafc",
  color:
    "#344563",
  fontWeight:
    600,
};

export default AgregarTipo;